import React from 'react';
import { cx } from '@/utils';

import { useLayoutContext } from '../Layout/LayoutProvider/LayoutContext';
import styles from './style.module.css';

const WrapperGrayScale = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  const {
    layout: { isGrayScaled, isHightContrast },
  } = useLayoutContext();

  const hightContraste = styles.hightContrast;

  return (
    <div
      className={cx(
        'w-full',
        className,
        { grayscale: isGrayScaled },
        isHightContrast ? hightContraste : null
      )}
    >
      {children}
    </div>
  );
};

export default WrapperGrayScale;
